import React from "react";
import CoinBalance from "./CoinBalance"; // Make sure the path is correct

// import { color } from "framer-motion";
import "./mywallet.css";

const MyWallet = () => {
  
  return (
    <div className="wallet-container" >
      <nav>
   
</nav>

      <CoinBalance />
    </div>
  );
};

export default MyWallet;